import form from './form';
import formModal from './formModal';

const appReducers = window.redux.combineReducers({
  form,
  formModal,
});

export default appReducers;
